import { useState, useEffect } from "react";

export const useCustomCountdown = (initialTime) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    if (!isRunning || timeLeft <= 0) return;
    const timer = setInterval(() => setTimeLeft((t) => t - 1000), 1000);
    return () => clearInterval(timer);
  }, [isRunning, timeLeft]);

  return [
    timeLeft,
    {
      start: () => setIsRunning(true),
      pause: () => setIsRunning(false),
      reset: () => setTimeLeft(initialTime),
    },
  ];
};
